import React from 'react'
import { J2Caution } from '@e3dc-react/icons'
import { makeStyles } from 'tss-react/mui'
import { useInstallationStatementDeadline } from '../../hooks'
import { Banner } from 'src/Components/banner'
import { BannerCloseTypes, BannerKey } from 'src/Libs/banners'

const useStyles = makeStyles()(theme => ({
  containerStyle: {
    backgroundColor: theme.palette.warning.light,
  },
  icon: {
    fontSize: theme.spacing(5),
    color: theme.palette.warning.main,
  },
}))

/**
 * This banner is shown in the overview page of installations,
 * if the installation statement is still incomplete and deadline is approaching (or over).
 */
const InstallationStatementDeadlineOverviewBanner: React.FC = () => {
  const { classes } = useStyles()
  const incompleteInstallations = useInstallationStatementDeadline()

  if (incompleteInstallations.length === 0) return <></>

  const bannerI18nKey =
    incompleteInstallations.length === 1
      ? 'installation.banner.installation-statement-deadline.overview.warning-text-single'
      : 'installation.banner.installation-statement-deadline.overview.warning-text-multiple'

  return (
    <Banner
      bannerKey={BannerKey.InstallationStatementDeadlineOverviewBanner}
      icon={<J2Caution className={classes.icon} />}
      i18nKey={bannerI18nKey}
      containerStyle={classes.containerStyle}
      closeType={BannerCloseTypes.Temporary}
    />
  )
}

export default InstallationStatementDeadlineOverviewBanner
